import { TypescriptTypeEnum } from '@y42/monaco-typescript-types';
import { FunctionDefinitionModel, FunctionParameter } from '../models/function-definition.model';

export function getFunctionDefinitionString(data: FunctionDefinitionModel[]): string | undefined {
  try {
    const getParamType = (param: FunctionParameter) =>
      param.typescript_type === TypescriptTypeEnum.ENUM ? param.enum_values : param.typescript_type;

    const _functionDefinitions = data
      .map((def) => {
        const paramPlaceholders = def.parameters && def.parameters.length > 0 ? def.parameters.map((p) => p.name) : '';
        const isWithRestParams = def.parameters.some((param) => !!param.allow_multiple_parameters);
        const firstParam = def.parameters[0];

        const params =
          isWithRestParams && firstParam
            ? `...${firstParam.name}: ${getParamType(firstParam)}`
            : def.parameters
                .map((param, i) => `${paramPlaceholders[i]}${!param.required ? '?' : ''}: ${getParamType(param)}`)
                .join(', ');

        return `
          /**
           * ${def.description}
           */
           declare function ${def.function_name}(${params}):${def.output_type_typescript} {}
          `;
      })
      .join('\n');
    return _functionDefinitions;
  } catch (error) {
    console.log(error);
    return undefined;
  }
}
